import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useInvoiceContext } from 'src/presentations/components/organisms/actionDetails/InvoiceContextProvider';
import { tFinancialService } from 'src/infra/services/tFinancialService';
import { cacheKeysUtil } from 'src/utils/cacheKeysUtil';

export const useDeleteAttachment = () => {
  const queryClient = useQueryClient();
  const { invoiceId } = useInvoiceContext();

  return useMutation(async (attachmentId: string) => tFinancialService.api.deleteAttachment(attachmentId), {
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries(cacheKeysUtil.invoiceSummaryUCT(invoiceId)),
        queryClient.invalidateQueries(cacheKeysUtil.invoiceSummary(invoiceId)),
        queryClient.invalidateQueries(cacheKeysUtil.actionDetails(invoiceId)),
        queryClient.invalidateQueries(cacheKeysUtil.actionDetailsUCT(invoiceId)),
      ]);
    },
  });
};
